import { Button } from "@/src/components/buttons";
import { closeDialog, openDialog } from "@/src/components/dialogs";
import { Task } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getUserId } from "@/src/utils/utils";
import moment from "moment";
import { UniqueTaskForm } from "./uniqueTaskForm";

export async function openTaskActions({
  task,
  onChange,
}: {
  task: Task;
  onChange: (newValue: Task | null | undefined) => void;
}) {
  function close() {
    closeDialog("taskActionsDialog");
  }
  return await openDialog({
    id: "taskActionsDialog",
    title: "Actions",

    content: (
      <div className="c1 gap10">
        <Button
          onClick={async () => {
            await openDialog({
              id: "uniqueTaskDrawer",
              title: "Ajouter une prise",
              content: (
                <UniqueTaskForm
                  current={task}
                  onChange={(newValue) => {
                    task = newValue;
                  }}
                />
              ),

              onConfirm: async () => {
                if (!task) return;
                await apiFetch(
                  "tasks",
                  "addMany",
                  { tasks: [task] },
                  "Erreur lors de l'ajout de la tâche"
                );
                onChange(task);
                close();
              },
            });
          }}
        >
          Modifier
        </Button>
        <Button
          type="tertiary"
          onClick={async () => {
            if (task.status == "finished") {
              task.status = "pending";
            } else {
              task.status = "finished";
              task.finishedDate = moment().format("YYYY-MM-DD HH:mm:ss");
              task.doctor = getUserId();
            }
            await apiFetch(
              "tasks",
              "addMany",
              { tasks: [task] },
              "Erreur lors de la mise à jour de la tâche"
            );
            onChange(task);
            close();
          }}
        >
          {task.status == "finished"
            ? "Marquer comme non fait"
            : "Marquer comme fait"}
        </Button>
        <Button
          color="red"
          type="tertiary"
          onClick={async () => {
            if (!task) throw new Error("Task is not defined");
            await apiFetch("general", "deleteAny", {
              id: task.id,
              table: "tasks",
            });
            onChange(null);
            close();
          }}
        >
          Supprimer
        </Button>
      </div>
    ),
  });
}
